/* eslint-disable quotes */
// @ts-nocheck
import TextField from '../../components/TextField';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import cn from 'classnames';
import { useAuthentication } from '../../contexts/AuthContext';
import { notification } from 'antd';
import { useState, useEffect } from 'react';

const VerifyCode = (props) => {
  const { setSelectedForm, email, setResetToken, purpose } = props;
  const { verifyResetCode, verifyEmailCode, sendResetCode, sendVerificationCode } = useAuthentication();
  const [countdown, setCountdown] = useState(120); // 60 seconds = 1 minute
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const schema = yup.object({
    code: yup.string().required('Verification code is required').length(6, 'Code must be 6 digits').nullable(),
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      if (purpose === 'reset') {
        const { resetToken } = await verifyResetCode(email, data.code);
        setResetToken(resetToken);
        setSelectedForm('ResetPassword');
      } else {
        await verifyEmailCode(email, data.code);
        notification.success({ message: 'Email verified successfully!', duration: 5 });
        // No need to manually navigate - the session token update will trigger a redirect
      }
    } catch (error) {
      notification.error({ message: error?.message || 'Invalid verification code', duration: 5 });
    }
  };

  const handleResendCode = async () => {
    try {
      if (purpose === 'reset') {
        await sendResetCode(email);
      } else {
        await sendVerificationCode(email);
      }
      setCountdown(120);
      setCanResend(false);
      notification.success({ message: 'New verification code sent to your email', duration: 5 });
    } catch (error) {
      notification.error({ message: error?.message || 'Failed to resend code', duration: 5 });
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div
      className={cn('font-Manrope h-full w-full rounded-[16px] bg-cover bg-center',
        `bg-[url(assets/images/loginFormBgGradientImg.svg)]`,
      )}
    >
      <div
        className="pt-[40px] flex items-center justify-center text-[28px] font-[700] text-[#030303] text-center"
      >
        {purpose === 'reset' ? 'Verify Reset Code' : 'Verify Email'}
      </div>
      <div
        className="px-[40px] py-[24px]"
      >
        <hr className="bg-clip-border bg-[#42E8E0] border-1 border-[#3B4DBC]" />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="px-[40px] gap-[24px]">
          <div className="">
            <TextField
              name="code"
              type="text"
              placeholder="Enter 6-digit verification code"
              label="Verification Code*"
              control={control}
              errors={errors}
              customHeight="56px"
              customlabelclass="leading-[42px] text-[20px]"
            />
          </div>
        </div>
        <div className="flex justify-center items-center pt-[32px] mx-16">
          <button
            type="submit"
            className="w-[486px] h-[59px] px-10 py-4 bg-gradient-to-b from-indigo-600 to-indigo-800
              rounded-md justify-center items-center gap-[12.72px] inline-flex"
          >
            <span className="text-white text-xl font-bold font-['Manrope']">Verify Code</span>
          </button>
        </div>
      </form>
      <div className="pt-8 pb-4 flex items-center justify-center">
        {!canResend ? (
          <span className="text-zinc-800 text-base font-medium font-['Manrope'] leading-normal">
            You can resend code in {formatTime(countdown)} minutes.
          </span>
        ) : (
          <>
            <span
              className="text-zinc-800 text-base font-medium font-['Manrope'] leading-normal"
            >
              Didn't receive the code?
            </span>
            <span
              className="text-indigo-700 text-base font-semibold font-['Manrope'] leading-normal"
            >
              &nbsp;
              {' '}
            </span>
            <span
              className="text-indigo-700 text-base font-semibold font-['Manrope'] underline leading-normal cursor-pointer"
              onClick={handleResendCode}
            >
              Resend Code
            </span>
          </>
        )}
      </div>
      <div className="pb-10 flex items-center justify-center">
        <span
          className="text-zinc-800 text-base font-medium font-['Manrope'] leading-normal"
        >
          Back to login?
        </span>
        <span
          className="text-indigo-700 text-base font-semibold font-['Manrope'] leading-normal"
        >
          &nbsp;
          {' '}
        </span>
        <span
          className="text-indigo-700 text-base font-semibold font-['Manrope'] underline leading-normal cursor-pointer"
          onClick={() => setSelectedForm('Login')}
        >
          Login Now
        </span>
      </div>
    </div>
  );
};

export default VerifyCode; 